import { map } from 'underscore';
import { Checkbox, Space } from 'antd';
import React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Loader } from 'app/components/loader';
import s from './index.module.scss';
import { Ok } from 'app/shared/assets';
import { useSelector } from 'react-redux';

export const ModalContent = ({
    onChange,
    items,
    className,
    checked,
    onOrder,
    isLoading,
    product = false,
}) => {
    const currency = useSelector((state) => state.pointsState.currency);
    return (
        <Space direction={'vertical'} size={'middle'}>
            {isLoading ? (
                <Loader />
            ) : (
                map(items, (item, index, arr) => {
                    const { name, id, price } = item;
                    return (
                        <Item
                            onOrder
                            key={id}
                            onUp={
                                typeof onOrder === 'function'
                                    ? () => onOrder(index, 1)
                                    : undefined
                            }
                            onDown={
                                typeof onOrder === 'function'
                                    ? () => onOrder(index, 0)
                                    : undefined
                            }
                            showUp={index !== 0}
                            showDown={index !== arr.length - 1}
                            className={className}
                            checked={
                                typeof checked === 'function'
                                    ? checked(item)
                                    : true
                            }
                            name={
                                !product ? (
                                    name
                                ) : (
                                    <>
                                        ${name} {price}
                                        {currency}
                                    </>
                                )
                            }
                            onChange={(e) => {
                                onChange(
                                    typeof checked === 'function'
                                        ? !checked(item)
                                        : !true,
                                    item
                                );
                            }}
                        />
                    );
                })
            )}
        </Space>
    );
};

export const Item = ({
    name,
    checked,
    onChange,
    className,
    onUp,
    onDown,
    showUp,
    showDown,
}) => {
    return (
        <Space style={{ display: 'flex', alignItems: 'center' }}>
            {onUp && onDown ? (
                <Space>
                    {showUp ? <ArrowUpOutlined onClick={onUp} /> : null}
                    {showDown ? <ArrowDownOutlined onClick={onDown} /> : null}
                </Space>
            ) : null}
            {checked ? (
                <div className={s.active_checkbox} onClick={onChange}>
                    <Ok />
                </div>
            ) : (
                <div className={s.common_checkbox} onClick={onChange}></div>
            )}
            <span className={className}>{name}</span>
        </Space>
    );
};
